import React, { FC, useEffect, useState } from "react";
import FormErrorMessage from "@/components/FormErrorMessage/FormErrorMessage";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Games } from "@/models/database/games/games.model";
import { createToast } from "@/utils/toaster/createToast";
import {
  AspectRatio,
  Box,
  Card,
  Grid,
  Heading,
  Inset,
  Text,
} from "@radix-ui/themes";

type GameProps = {
  name: string;
  value: string;
  gameCover: string;
};

const ChallengeGamePicker: FC<{
  label: string;
  value: string;
  setFieldValue: any;
  errors: any;
  name: string;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}> = ({ value, label, setFieldValue, errors, name, setStep }): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true);
  const handleChange = (gameName, gameValue) => {
    if (
      games.find((game) => {
        return game.name === gameName;
      })?.isUpcoming
    ) {
      return createToast({
        type: "info",
        message: "This game is currently not supported. Come back later!",
      });
    }
    setFieldValue(name, gameName);
    setFieldValue("gameType", gameValue);
    setStep((s) => s + 1);
  };

  const [games, setGames] = useState<Games[]>([]);

  useEffect(() => {
    const getGames = async () => {
      const games = collectionRef.games;
      const gamesRes = await games.where("isDisplayed", "==", true).get();
      setLoading(false);
      setGames(
        gamesRes.docs
          .map((doc) => {
            return doc.data() as Games;
          })
          .sort((a, b) => {
            if (!a.isUpcoming && b.isUpcoming) {
              return -1;
            }
            return 0;
          })
      );
    };
    getGames();
  }, []);

  return (
    <>
      <Heading as="h2" size="4" mb="2">
        {label}
      </Heading>
      <Grid columns={{ initial: "1", lg: "4" }} gap="3">
        {games &&
          games.map((game) => {
            return (
              <Box key={game.name}>
                <Card
                  className="card"
                  onClick={() => {
                    handleChange(game.name, game.value);
                  }}
                  data-value={game.name}
                >
                  <Inset clip="padding-box" side="top" pb="current">
                    <AspectRatio ratio={6 / 9}>
                      <img
                        src={game.gameCover}
                        alt={game.name}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </AspectRatio>
                  </Inset>
                  <Heading as="h3" size="2" mb="0">
                    {game.isUpcoming ? "Coming soon" : game.name}
                  </Heading>
                </Card>
              </Box>
            );
          })}
      </Grid>
      {errors && errors[name] && (
        <FormErrorMessage
          text={errors[name] as string}
          isVisible={!!errors[name]}
        />
      )}
    </>
  );
};

export default ChallengeGamePicker;
